import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import MainLayout from './components/Layout/MainLayout';
import WordListsPage from './pages/WordListsPage';
import WordListDetailPage from './pages/WordListDetailPage';
import StudyPage from './pages/StudyPage';
import SettingsPage from './pages/SettingsPage';
import LoginForm from './components/auth/LoginForm';
import DefinitionGame from './components/games/DefinitionGame/Game';
import FlashcardGame from './components/games/FlashcardGame/FlashcardGame.js';
import { useAuth } from './components/auth/AuthContext';
import { AuthProvider } from './components/auth/AuthContext';
import { NotificationProvider, useNotification } from './components/shared/NotificationContext';
import Notification from './components/shared/Notification';

const NotificationRoot = () => {
  const { notification, clearNotification } = useNotification();
  if (!notification) return null;
  return (
    <Notification
      message={notification.message}
      type={notification.type}
      duration={notification.duration}
      onClose={clearNotification}
    />
  );
};

function App() {
  const { isAuthenticated, error, isLoading, login, registerInit, registerVerify, logout } = useAuth();
  const { notifyError } = useNotification();
  const [registrationData, setRegistrationData] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    if (data.error) {
      notifyError(data.error);
      return;
    }

    if (data.success) {
      try {
        // Pomyślna weryfikacja kodu - tworzymy konto
        await registerVerify(data.verificationId, data.code);
      } catch (error) {
        notifyError(error.message);
      }
      return;
    }

    if (data.message) {
      // Kod weryfikacyjny został wysłany
      setRegistrationData(data);
      return;
    }

    try {
      // Standardowe logowanie
      await login(data.email, data.password);
    } catch (error) {
      notifyError(error.message);
    }
  };

  if (isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<MainLayout onLogout={logout} />}>
          <Route index element={<Navigate to="/lists" />} />
          <Route path="lists" element={<WordListsPage />} />
          <Route path="lists/:id" element={<WordListDetailPage />} />
          <Route path="study" element={<StudyPage />} />
          <Route path="study/definition-game" element={<DefinitionGame />} />
          <Route path="study/flashcards" element={<FlashcardGame />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/lists" />} />
        </Route>
      </Routes>
    );
  }

  return (
    <LoginForm
      onSubmit={handleSubmit}
      isLoading={isLoading}
      error={error}
      registrationData={registrationData}
      navigate={navigate}
    />
  );
}

// Wrap App with Router and AuthProvider
const AppWithRouter = () => (
  <Router>
    <NotificationProvider>
      <AuthProvider>
        <App />
        <NotificationRoot />
      </AuthProvider>
    </NotificationProvider>
  </Router>
);

export default AppWithRouter;
